import { render, staticRenderFns } from "./NoInternetConnection.vue?vue&type=template&id=96f2950e&scoped=true&"
import script from "./NoInternetConnection.vue?vue&type=script&lang=js&"
export * from "./NoInternetConnection.vue?vue&type=script&lang=js&"
import style0 from "./NoInternetConnection.vue?vue&type=style&index=0&id=96f2950e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f2950e",
  null
  
)

component.options.__file = "NoInternetConnection.vue"
export default component.exports